import { Provider } from '@angular/core';
import { AGENDA_SIGNING_REPOSITORY } from './application/agenda-signing.tokens';
import { HttpAgendaSigningRepository } from './infrastructure/http/http-agenda-signing.repository';
import { GetAllAgendaSigningUseCase } from './application/get-all-agenda-signing.usecase';
import { GetAgendaReservationDatesUseCase } from './application/get-agenda-reservation-dates.usecase';
import { CreateReservationUseCase } from './application/create-reservation.usecase';
import { CancelReservationUseCase } from './application/cancel-reservation.usecase';
import { RescheduleReservationUseCase } from './application/reschedule-reservation.usecase';

export const AGENDA_SIGNING_PROVIDERS: Provider[] = [
  { provide: AGENDA_SIGNING_REPOSITORY, useClass: HttpAgendaSigningRepository },
  GetAllAgendaSigningUseCase,
  GetAgendaReservationDatesUseCase,
  CreateReservationUseCase,
  CancelReservationUseCase,
  RescheduleReservationUseCase,
];
